import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconInput(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5c-1.1 0-2-.9-2-2v-2c0-.55.45-1 1-1s1 .45 1 1v2h14V5H5v2c0 .55-.45 1-1 1s-1-.45-1-1V5c0-1.1.9-2 2-2h14Zm-4.293 9.707a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L11.586 11H4a1 1 0 1 0 0 2h7.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
